<template>
    <div>
        <b-alert :show="isSuccess" variant="success" class="mb-3">
            Your genres have been updated.
        </b-alert>

        <div class="form-group row">
            <div class="col-6 col-md-3" v-for="genre in genres" v-bind:key="genre.id">
                <div class="custom-control custom-checkbox">
                    <input :id="'genre'+ genre.id" type="checkbox" class="custom-control-input" v-model="user.genres" :value="genre.id" :disabled="isBusy">
                    <label :for="'genre'+ genre.id" class="custom-control-label">
                        {{ genre.name }}
                    </label>
                </div>
            </div>
        </div>
        <small class="form-text text-muted">
            Select as many as you like.
        </small>

        <div class="row">
            <template v-if="!isOnboarding">
                <div class="col-md-6">
                    <button class="btn btn-success mt-3" :disabled="isBusy" @click="save">Save</button>
                </div>
            </template>
            <template v-else>
                <div class="col-md-6">
                    <button class="btn btn-primary mt-3" :disabled="isBusy" @click="saveOnboarding">Next</button>
                </div>

                <div class="col-md-6 align-self-end">
                    <div class="text-right">
                        <button class="btn btn-secondary btn-sm skip" :disabled="isBusy" @click="skip">Skip</button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isOnboarding: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                user: {
                    genres: [], 
                },
                genres: [],
                isSuccess: false,
                isBusy: false,
                isFormBusy: false,
            }
        },

        mounted() {
            this.getGenres();
        },

        methods: {
            // Skip
            skip() {
                Bus.$emit('stepComplete', {
                    'step': 'genres',
                    'skip': true,
                });
            },

            // Save
            save() {
                this.isSuccess = false;
                this.isBusy = true;

                axios.post('/api/me/update', {
                    'user': this.user
                }).then((response) => {                    
                    this.isSuccess = true;
                    this.isBusy = false;
                });
            },

            // Save
            saveOnboarding() {
                this.isBusy = true;

                axios.post('/api/me/update', {
                    'user': this.user
                }).then((response) => {
                    this.isBusy = false;

                    Bus.$emit('stepComplete', {
                        'step': 'genres',
                        'skip': false,
                        'percentageComplete': response.data.profileCompletePercentage,
                    });
                });
            },

            // Get all genres
            getGenres() {
                this.isBusy = true;

                axios.get('/api/me/genres').then((response) => {
                    this.genres = response.data.genres;
                    this.user.genres = response.data.selectedGenres;
                    this.isBusy = false;
                });
            },
        }
    }
</script>